module.exports = __webpack_public_path__ + "static/media/Gemstone Report 2.8235a784.jpg";